import React from 'react';
import { Route, Switch } from "react-router-dom";
import { Redirect } from 'react-router';
import { LoginView, LogoutView, BundlesView, OptionsView, PaymentView, OrderView, CheckoutView, FinishedView, NotFoundView, PayeverView } from '../views';

import RouteAuthenticated from './RouteAuthenticated';
var AppConfig = require('../config.json');


export default (
	<Switch key="Switch">
	<Redirect exact from="/" to={AppConfig.links.bundles.url}/>
	<Route exact path={`/${AppConfig.links.login.url}`} component={LoginView} key="LoginView" />
	<RouteAuthenticated exact path={`/${AppConfig.links.bundles.url}`} component={BundlesView} key="BundlesView" />
	<RouteAuthenticated exact path={`/${AppConfig.links.options.url}`} component={OptionsView} key="OptionsView" />
	<RouteAuthenticated exact path={`/${AppConfig.links.payment.url}`} component={PaymentView} key="PaymentView" />
	<RouteAuthenticated exact path={`/${AppConfig.links.order.url}`} component={OrderView} key="OrderView" />
	<RouteAuthenticated exact path={`/${AppConfig.links.checkout.url}`} component={CheckoutView} key="CheckoutView" />
	<RouteAuthenticated exact path={`/${AppConfig.links.payever.url}`} component={PayeverView} key="PayeverView" />
	<RouteAuthenticated exact path={`/${AppConfig.links.finished.url}`} component={FinishedView} key="FinishedView" />
	<RouteAuthenticated exact path="/logout" component={LogoutView} key="LogoutView" />
	<Route path="/404" component={NotFoundView} key="NotFoundView" />
	<Route component={NotFoundView} key="NotFoundView2" />
	</Switch>
);



// WEBPACK FOOTER //
// ./src/routes/index.js